import { useEffect, useState } from "react"
import { useAppSelector } from "../../../app/hooks"

import { IBaseFieldProperties } from "./interfaces"
import { RadioBooleanValueLabel } from "./interfaces"

export interface RadioBooleanFieldProperties extends IBaseFieldProperties {
  value?: boolean
  width?: string
  options: RadioBooleanValueLabel[]
  className?: string
  name?: string
}

export const RadioBooleanField = (props: RadioBooleanFieldProperties) => {
  const { useLocalTime } =
    useAppSelector(
      (state) => state["selectionReducer"].airportSeasonsSelector
    ) || {}
  const [value, setValue] = useState(props.value)

  useEffect(() => {
    setValue(props.value)
  }, [props.value])

  const handleOnValueChange = () => {
    setValue(!value)

    if (typeof props.onChange === "function") {
      props.onChange(props.name, !value, false)
    }
  }

  return (
    <div
      className={
        "ocs-field-container " +
        (!props.caption ? " h-50 d-flex align-items-end " : "") +
        (props.className ? props.className : "")
      }
    >
      {props.caption && <label htmlFor="">{props.caption}</label>}
      {props.readonly ? (
        <p
          className={
            "ocs-field-readonly" +
            (props.hasChanges
              ? useLocalTime
                ? " has-changes local-time"
                : " has-changes"
              : "")
          }
        >
          {props.options[0].value === value
            ? props.options[0].label
            : props.options[1].label}
        </p>
      ) : (
        <div className="radio-field-container">
          <div className="radio-field">
            <label className="ocs-radio-container d-flex align-items-center">
              <input
                type="radio"
                onChange={() => handleOnValueChange()}
                checked={props.options[0].value === value}
                name={props.name}
              />
              <span className="ocs-radio-check" />
              {props.options[0].label}
            </label>
          </div>
          <div className="radio-field">
            <label className="ocs-radio-container d-flex align-items-center">
              <input
                type="radio"
                onChange={() => handleOnValueChange()}
                checked={props.options[1].value === value}
                name={props.name}
              />
              <span className="ocs-radio-check" />
              {props.options[1].label}
            </label>
          </div>
        </div>
      )}
    </div>
  )
}

export default RadioBooleanField
